import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const PaymentGatewaySetupForEcommerceInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Payment Gateway Setup for E-commerce in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Seamless Payments</Subheading>}
        heading={
          <Heading>
            Payment Gateway{" "}
            <span tw="text-primary-500">Setup for E-commerce</span> in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer expert payment gateway setup for
            e-commerce in **Dubai**, ensuring secure, fast, and reliable
            transactions for your online store. Simplify payments and boost
            customer trust with our solutions.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // E-commerce checkout
          "https://images.unsplash.com/photo-1580048915913-4f8f5cb481c4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Payment security
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Credit card payment
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Set Up Payments Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Effortless Payment Solutions in Dubai"
        description="We integrate payment gateways that work for you."
        cards={[
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Transactions",
            description: "Advanced encryption for safe payments.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Multiple Options",
            description: "Support for cards, wallets, and more.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Integration",
            description: "Quick setup with minimal downtime.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Friendly",
            description: "Smooth payments on all devices.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Setup",
            description: "Tailored to your e-commerce platform.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Service",
            description: "Dubai’s top payment gateway experts.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Payment Gateway Setup Process"
        description={
          <Description>
            We streamline your payment system with ease:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Assess your store’s payment needs.</li>
              <li>Selection: Choose the best gateway for you.</li>
              <li>Integration: Seamlessly connect it to your store.</li>
              <li>Testing: Ensure secure and smooth transactions.</li>
              <li>Launch: Go live with reliable payments.</li>
              <li>Support: Offer ongoing assistance and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556742111-a301076d9d18?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Payment system integration
          "https://images.unsplash.com/photo-1601597111158-2fceff292cdc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Secure transaction
          "https://images.unsplash.com/photo-1571867424488-4565932edb41?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Payment gateway testing
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Payment Success in Dubai"
        description="Our setups drive e-commerce growth."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Increase",
            description: "Boosted checkout completions by 30%.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Deployment",
            description: "Payment gateway live in 48 hours.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "97% satisfaction with payment ease.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Secure Payments?</Subheading>}
        heading="Payment Gateway Setup for E-commerce in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for payment gateway setup for e-commerce
            in Dubai. Ensure fast, secure transactions for your
            customers—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1593510987185-1ec2256148a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Mobile payment
          "https://images.unsplash.com/photo-1534224039826-c7a0fb1c5c1c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80", // Dubai skyline for local context
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
